import { ImageProps } from "@omni/types/components/props/image.props";
import { Image } from "@omni/ui/components/Image/image";

export const ImageDefault = (props: ImageProps) => {
    return (
        <Image {...props}>
            <Image.Img />
        </Image>
    );
};
